import { render, staticRenderFns } from "./DepartBuildingLot.vue?vue&type=template&id=61815c1a&"
import script from "./DepartBuildingLot.vue?vue&type=script&lang=js&"
export * from "./DepartBuildingLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports